module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "dismissible": "",
      "show": _vm.showDismissibleAlert
    },
    on: {
      "dismissed": function($event) {
        _vm.showDismissibleAlert = false
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.messageAlert) + "\n  ")])], 1), _vm._v(" "), (_vm.exibirGrafico) ? _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', _vm._l((_vm.relatorios.tabela), function(data, index) {
    return _c('th', {
      key: index
    }, [_vm._v(_vm._s(index))])
  }), 0)]), _vm._v(" "), _c('tbody', [_c('tr', _vm._l((_vm.relatorios.tabela), function(data, index) {
    return _c('td', {
      key: index
    }, _vm._l((data), function(valor, campo) {
      return _c('p', {
        key: campo
      }, [_c('strong', [_vm._v(_vm._s(campo) + ": ")]), (campo === 'Total') ? _c('span', {
        staticClass: "label label-success"
      }, [_vm._v(_vm._s(valor))]) : _c('span', {
        staticClass: "label label-default"
      }, [_vm._v(_vm._s(valor))])])
    }), 0)
  }), 0)])])])])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header col-md-12"
  }, [_c('h3', [_vm._v("Requisitos de pesquisa")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("Data Inicial")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('datepicker', {
    attrs: {
      "language": _vm.ptBR,
      "placeholder": "Selecione a data inicial",
      "id": "dataInicioBusca"
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Data Final")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('datepicker', {
    attrs: {
      "language": _vm.ptBR,
      "placeholder": "Selecione a data final",
      "id": "dataFimBusca"
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group col-sm-4"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "codigo"
    }
  }, [_vm._v("Código")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa.codigo),
      expression: "pesquisa.codigo"
    }],
    staticClass: "form-control col-sm-4",
    attrs: {
      "id": "codigo",
      "placeholder": "Digite o Código ou importe o arquivo"
    },
    domProps: {
      "value": (_vm.pesquisa.codigo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pesquisa, "codigo", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-4"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "maquinas"
    }
  }, [_vm._v("Máquina")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa.idcontrolador),
      expression: "pesquisa.idcontrolador"
    }],
    staticClass: "form-control col-sm-4",
    attrs: {
      "id": "maquinas"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.pesquisa, "idcontrolador", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Selecione a Máquina")]), _vm._v(" "), _vm._l((_vm.monitores), function(monitor) {
    return _c('option', {
      key: monitor.id,
      domProps: {
        "value": monitor.id
      }
    }, [_vm._v(_vm._s(monitor.nomemaquina))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('text-reader', {
    on: {
      "load": function($event) {
        return _vm.enviarTexto($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.enviarTexto
    }
  }, [_vm._v("\n               Importar arquivo .csv\n             ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.efetuarPesquisa()
      }
    }
  }, [_vm._v("\n              Efetuar Pesquisa\n            ")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Produção por código/tag")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1726584c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/RelatoriosProducaoOF.vue
// module id = 635
// module chunks = 1